import { BehaviorSubject } from 'rxjs';
import { SlsService } from 'src/app/core/services/sls.service';
import { Injectable } from '@angular/core';
import { LoginData } from '../models/login-data';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

/* --------------------------------- Fields --------------------------------- */
  isLoggedInSubject = new BehaviorSubject<boolean>(false);
/* ------------------------------- Constructor ------------------------------ */

  constructor(private sls: SlsService, private router: Router) {
    this.setLoggedInSubject();
   }

   getLoginData(): LoginData{
     const loginUserData = this.sls.get('loginData');
     if(loginUserData != '' && !loginUserData.directory_category_id && loginUserData.type != 'ADMIN') {
      console.trace('getLoginData called');
      console.log("Login Data", loginUserData);
      this.router.navigate(['/profile/directory/add']);
     }
     return this.sls.get('loginData') as LoginData;
   }

   getLoginDataDirectory(): LoginData{
    return this.sls.get('loginData') as LoginData;
  }

   removeLoginData(){
     this.sls.remove('loginData');
   }

   setLoggedInSubject(){
    const loginData =  this.sls.get('loginData');
    console.log("setLoggedInSubject", loginData);
    if(loginData){
      this.isLoggedInSubject.next(true);
    } else {
      this.isLoggedInSubject.next(false);
    }
   }

updateLoginData(fields: Partial<LoginData>) {
  const loginData = this.sls.get('loginData') as LoginData;
  if (loginData) {
    const updated = { ...loginData, ...fields };
    console.log('Updated loginData:', updated);
    this.sls.set('loginData', updated);
    this.setLoggedInSubject();
  } else {
    console.error('No loginData found in storage');
  }
}
  
getReturnUrl(): string | null {
  return this.sls.get('returnUrl') || null;
}

}
